import React from 'react';
import { Switch } from 'antd';

/**
 * Props for the ToggleSwitch component.
 */
interface ToggleSwitchProps {
  /** Callback function triggered when the switch state changes. */
  onChange?: (checked: boolean) => void;
  /** Determines if the switch is turned on. */
  checked?: boolean;
  /** Disables the switch when set to true. */
  disabled?: boolean;
  /** Value of the switch, can be used for form handling. */
  value?: boolean;
}

/**
 * A toggle switch component using Ant Design's Switch.
 *
 * @param {ToggleSwitchProps} props - The component props.
 * @returns {JSX.Element} The rendered ToggleSwitch component.
 */
const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ onChange, checked = true, disabled = false, value = false }) => {
  return (
    <Switch
      style={{
        backgroundColor: checked ? '#6851D6' : undefined,
        width: '30px',
        height: '16px',
      }}
      onChange={onChange}
      checked={checked}
      defaultChecked
      size="small"
      disabled={disabled}
      value={value}
      className="switchComponent"
      id="switchComponent"
    />
  );
};

export default ToggleSwitch;
